import React from "react";
import { connect } from "react-redux";
import InputMask from "react-input-mask";

function Input(props) {
  const {
    onEnterPress,
    onFocus,
    value,
    loading,
    onChange,
    type,
    placeholder,
    id,
    className,
    mask,
    disabled
  } = props;
  if (mask) {
    return (
      <InputMask
        mask={mask}
        onKeyPress={e => {
          if (e.key === "Enter") {
            if (onEnterPress) {
              onEnterPress();
            }
          }
        }}
        onFocus={e => {
          if (onFocus) {
            onFocus();
          }
        }}
        value={value}
        disabled={loading || disabled}
        onChange={e => {
          const { value } = e.target;
          let v = value.replace(/[()_. /-]/g, "");
          if(onChange){
            onChange( v );
          }
        }}
        type={type || "text"}
        placeholder={placeholder}
        className={className || "form-control mb-0"}
        required
        id={id}
      />
    );
  }

  return (
    <input
      onKeyPress={e => {
        if (e.key === "Enter") {
          if (props.onEnterPress) {
            onEnterPress();
          }
        }
      }}
      onFocus={e => {
        if (props.onFocus) {
          props.onFocus();
        }
      }}
      value={props.value}
      disabled={props.loading || disabled }
      onChange={e => {
        if(onChange){
          onChange(e.target.value);
        }
      }}
      type={props.type || "text"}
      placeholder={props.placeholder}
      className={className || "form-control mb-0"}
      required
      id={props.id}
    />
  );
}

const mapStateToProps = state => ({
  loading: state.loading
});
export default connect(mapStateToProps)(Input);



// WEBPACK FOOTER //
// ./src/components/theme/form/input/input.jsx